// extracted by mini-css-extract-plugin
module.exports = {"root":"SubmitButton__root___VKWcd","red":"SubmitButton__red___qgjsh","disabled":"SubmitButton__disabled___3SXMa"};